module.exports = __webpack_public_path__ + "img/case4.5f38397b.jpg";